module.exports = __webpack_public_path__ + "static/img/2.b5ded6cd.png";